module.exports = __webpack_public_path__ + "img/Mo.402af57d.402af57d.png";